import DocumentTitle from 'react-document-title';
import { useEffect, useState } from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import docsService, { Doc } from '../../../../services/DocsService';
import { DocLink } from '../../../../components/DocLink';

const categoryDocSlug = 'precontractual_docs';

export const PrecontractualInformation = () => {
    const [docs, setDocs] = useState<Doc[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        docsService.docsByCategoryDoc(categoryDocSlug).then((docs: Doc[]) => {
            setDocs(docs);
        }).finally(() => {
            setIsLoading(false);
        })
    }, []);

    return (
        <DocumentTitle title="IronIA - Información Precontractual">
            <>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col">
                        <h2>Información Precontractual</h2>
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col">
                        {isLoading && (
                            <Spinner size={SpinnerSize.large} />
                        )}
                        {docs.length === 0 && !isLoading && (
                            <p>No hay documentos disponibles.</p>
                        )}
                        {docs.length > 0 && !isLoading && (
                            <ul style={{marginTop: "2em"}}>
                                {docs.map((doc: Doc, index: number) => (
                                    <li key={index} style={{lineHeight: '2.5em'}}>
                                        <DocLink
                                            fileName={doc.name}
                                            docId={doc.id}
                                        />
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </>
        </DocumentTitle>
    )
}